import { render, staticRenderFns } from "./FaqTabs.vue?vue&type=template&id=4ac0bf88&scoped=true&"
import script from "./FaqTabs.vue?vue&type=script&lang=ts&"
export * from "./FaqTabs.vue?vue&type=script&lang=ts&"
import style0 from "./FaqTabs.vue?vue&type=style&index=0&id=4ac0bf88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac0bf88",
  null
  
)

export default component.exports